import cx from 'classnames';
import { FC, ReactElement } from 'react';

import classes from './Container.module.scss';
import { ContainerProps } from './Container.types';

export const Container: FC<ContainerProps> = ({
  children,
  size = 'medium',
  className,
}): ReactElement => (
  <div className={cx(classes.container, classes[`container--${size}`], className)}>{children}</div>
);
